import UserManagement from "../Users/UserManagement";

// Reuse the user management table, in sales-only mode based on the route.
export default function SalesRepresentatives() {
  return <UserManagement />;
}
